// Coffeescript transformed to Javascript via https://awsm-tools.com/code/coffee2js

export const coffeeExtends = function (child, parent) {
    for (var key in parent) {
        if (_hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
        this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
};
const _hasProp = {}.hasOwnProperty;
